import { render, staticRenderFns } from "./KerkenFilter.vue?vue&type=template&id=7da79564&scoped=true"
import script from "./KerkenFilter.vue?vue&type=script&lang=js"
export * from "./KerkenFilter.vue?vue&type=script&lang=js"
import style0 from "./KerkenFilter.vue?vue&type=style&index=0&id=7da79564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da79564",
  null
  
)

export default component.exports